<template>
    <div :class="{ selected }" class="plan">
        <div class="header">{{ $t("wp.whatsappPlusPlanTitle") }}</div>
        <div class="plan-price-section">
            <div class="plan-price-details">
                <span :class="{ tl: site.basePrice.currency === 'tl' }" class="amount">{{
                    $_.get(site, "whatsappPlusBasePrice.value", DEFAULT_PRICING.PLUS.tl.price)
                }}</span>
                <i
                    ><i class="slash">/</i>
                    <i class="billed-month"
                        >{{ $t("billing.month") }}
                        <i class="billed-yearly hide"><br />{{ $t("billing.billedMonthToMonth") }}</i></i
                    ></i
                >
            </div>
        </div>
        <!--@click="updateIntegration('whatsapp', true)"-->
        <md-button
            :disabled="selected"
            class="md-raised md-primary w-100"
            style="transform: scale(0.7); font-size: x-large; border-radius: 10%"
            @click="onSelected"
            >{{ $t(selected ? "wp.subscribed" : "wp.subscribe") }}
        </md-button>
        <span class="text-succes">-</span>
        <a-divider>{{ $t("wp.planDetails") }}</a-divider>
        <div class="features">
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.includesAllBasicPlans") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span class="text-success">{{ $t("wp.chatbotIntegration") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span class="text-success">{{ $t("wp.messageToNewNumbers") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span class="text-success">{{ $t("wp.broadcastMessageToEveryone") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span class="text-success">{{ $t("wp.personalizedBroadcastMessage") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.customerGroupSegmentation") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.scheduleBroadcastMessage") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.featureButtonsMessageSupport") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.featureGalleryMessageSupport") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.featureQuickReplyMessageSupport") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.locationMessageSupport") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.advancedSpamPreventions") }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import CONFIG from "../../../config/config";

export default {
    name: "WhatsappPlusPlanCard",
    props: {
        onSelected: {
            type: Function,
            default: () => {},
        },
        selected: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters({}),
        ...mapState({
            siteId: (state) => state.site.site._id,
            site: (state) => state.site.site,
            wpInfo: (state) => state.whatsapp.info,
        }),
    },
    data() {
        return {
            DEFAULT_PRICING: CONFIG.PRICING.WHATSAPP,
        };
    },
};
</script>

<style scoped></style>
